import { useState } from "react";
import LoadingHome from "../../Components/Home/LoadingHome";
import MobileHeroSection from "../../Components/Home/Mobile/MobileHeroSection";
import MobileAboutMe from "../../Components/Home/Mobile/MobileAboutMe";
import MobilePreviewSection from "../../Components/Home/Mobile/MobilePreviewSection";

export default function MobileHome() {
    const [imagesLoaded, setImagesLoaded] = useState(false);
    return (
        <>
            <style>{'body { background-color: var(--color-light); background-image:none; }'}</style>
            <LoadingHome imagesLoaded={imagesLoaded} />
            <MobileHeroSection setImagesLoaded={setImagesLoaded} />
            <MobileAboutMe />
            <MobilePreviewSection />
        </>
    );
}